import store from '~/store';
import isObject from 'lodash/isObject';

export const hideErrorMsg = (type, val, actionFn) => { //
  let errorMsg;
  if (isObject(val)) {
    errorMsg = val.error;
  } else {
    errorMsg = val;
  }
  if (!errorMsg) {
    return null;
  }
  setTimeout(() => {
    store.dispatch((dispatch) => actionFn(dispatch, {type: type, val}));
  }, 4000);

  return errorMsg;
};



// WEBPACK FOOTER //
// ./src/misc/hideErrorMsg.js